export default (element => element && element.jquery ? element[0] : element);